export { MovimientosCajaIndex } from "./container/index";


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/movimientoscajaruta/index.tsx